export default function getMerchantCallback() {
  return window.onVisaCheckoutReady || window.onVmeReady;
}
